/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type DeploymentGit = {
  /**
   * The git commit SHA this deployment was built from.
   */
  commitSha: string;
  /**
   * The git branch this deployment was built from. Omitted when unknown.
   */
  branch?: string | undefined;
};

/** @internal */
export const DeploymentGit$inboundSchema: z.ZodType<
  DeploymentGit,
  z.ZodTypeDef,
  unknown
> = z.object({
  commitSha: z.string(),
  branch: z.string().optional(),
});

export function deploymentGitFromJSON(
  jsonString: string,
): SafeParseResult<DeploymentGit, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => DeploymentGit$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'DeploymentGit' from JSON`,
  );
}
